import { TLocale, TRegionInstance } from '@northladder/utilities';

import { ITenantConfig, TSetRegionState } from '../types';

import { persistRegionStore } from './regionStoreLocalStorageUtils';

/**
 * This updates the active region based on the selected region in the UI.
 */
export function updateActiveRegionCallback(set: TSetRegionState) {
  return function updateActiveRegionInStore(updatedRegion: TRegionInstance) {
    set(({ appLanguage, tenantConfig }) => {
      persistRegionStore({
        appLanguage,
        region: updatedRegion,
        tenantConfig,
      });

      return { region: updatedRegion };
    });
  };
}

/**
 * This updates the app language based on the selected language in the UI.
 */
export function updateAppLanguageCallback(set: TSetRegionState) {
  return function updateAppLanguageInStore(updatedLanguage: TLocale) {
    set(({ region, tenantConfig }) => {
      persistRegionStore({
        appLanguage: updatedLanguage,
        region,
        tenantConfig,
      });

      return { appLanguage: updatedLanguage };
    });
  };
}

/**
 * This updates the app tenantConfig based on the selected tenantConfig in the UI.
 */
export function updateTenantConfig(set: TSetRegionState) {
  return function updateTenantConfigInStore(
    updatedTenantConfig: ITenantConfig | null
  ) {
    set(({ appLanguage, region }) => {
      persistRegionStore({
        appLanguage,
        region,
        tenantConfig: updatedTenantConfig,
      });

      return { tenantConfig: updatedTenantConfig };
    });
  };
}
